import { customAxios } from './customAxios';

export async function scartaNotificaMonitoraggio(idNotifica, nota) {
    const config = {
        params: { id_notifica: idNotifica, nota },
        headers: {
            Accept: '*/*',
            'AuthToken': JSON.parse(localStorage.getItem('token')),
        },
    };
    try {
        const response = await customAxios.post(`${process.env.REACT_APP_BACKEND_HOST}/adv/monitoraggio/notifica/scarta`, null, config);
        return response.data;
    } catch (error) {
        console.error('Errore durante lo scarto della notifica:', error);
        throw error;
    }
}
